import React, { useEffect } from 'react'
import classes from './Profile.module.css'
import Navbar from '../Components/Navbar'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { unsub_api } from '../Services/Apis'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Profile = () => {
    const number = Cookies.get('sub_number')
    const params = new URLSearchParams(window.location.search);
    const extId = params.get('ext_ref')

    const navigate = useNavigate();
    useEffect(()=>{
        if(!number){
            navigate('/subscribe')
        }
    },[])

    const handleUnsubscribe=async()=>{
      try{
         const res = await axios.get(`${unsub_api}?msisdn=${number}`)
         console.log(res.data)
         Cookies.remove('sub_number')

         if(res.data == 'DEACTIVATE_SUBSCRIPTION_SUCCESSFUL'){
            navigate(`/subscribe?ext_ref=${extId}`)
         }
         else{
            toast.error('Unsubscription Failed, Try Again Later!!')
         }

         
      }
      catch(err){
         console.log(err)
      }
    }


  return (
    <div className={classes.container}>
     {
        number &&
        <>
        <Navbar/>
     <div className={classes.main}>
     
     <div className={classes.sub_container}>
     <p className={classes.num}>User Profile</p>
     <img src='https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg' alt='...' className={classes.img}/>
     <p className={classes.num}>+{number}</p>
     <button className={classes.btn} onClick={handleUnsubscribe}>
        UnSubscribe
     </button>
     </div>

     </div> 
        </>
     }
    </div>
  )
}

export default Profile
